import { StatusAnnouncer } from "../shared/components/feedback/status-announcer.js";
import { Container } from "../shared/components/layout/container.js";
import { AudioErrorDialog } from "../shared/skins/shared/audio/error-dialog.js";
import { LivePlaybackHotkeys } from "../shared/skins/shared/live-playback-hotkeys.js";
import { MinimalLiveAudioControls } from "./controls.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/minimal-live-audio/skin.tsx
/** @jsxImportSource react */
function MinimalLiveAudioSkin({ children, className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(Container, {
		className: cn("audio-skin", className),
		"data-theme": "minimal",
		"data-preset": "live-audio",
		...props,
		children: [
			children,
			/* @__PURE__ */ jsx(AudioErrorDialog, {}),
			/* @__PURE__ */ jsx(MinimalLiveAudioControls, {}),
			/* @__PURE__ */ jsx(LivePlaybackHotkeys, {}),
			/* @__PURE__ */ jsx(StatusAnnouncer, {})
		]
	});
}
//#endregion
export { MinimalLiveAudioSkin };

//# sourceMappingURL=skin.js.map